var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExactTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 19H22V20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V19H19C17.8954 19 17 19.8954 17 21V22H33V21C33 19.8954 32.1046 19 31 19H30V20C30 20.5523 29.5523 21 29 21C28.4477 21 28 20.5523 28 20V19ZM30 17H31C33.2091 17 35 18.7909 35 21V31C35 33.2091 33.2091 35 31 35H19C16.7909 35 15 33.2091 15 31V21C15 18.7909 16.7909 17 19 17H20V16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16V17H28V16C28 15.4477 28.4477 15 29 15C29.5523 15 30 15.4477 30 16V17ZM33 24H17V31C17 32.1046 17.8954 33 19 33H31C32.1046 33 33 32.1046 33 31V24Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExactTime);
export default __webpack_public_path__ + "static/media/exactTime.fb17cdd7ba8e7692163a334007238814.svg";
export { ForwardRef as ReactComponent };